import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  schema,
}) {
  return (
    <Helmet>
      <title>
        {" "}
        India’s No.1 all in one Salon Management Software | Salon Management
        Software{" "}
      </title>

      {/* <meta name="description" content={description} /> */}
      <meta
        name="description"
        content="Elegant Prime is India’s No.1 all-in-one Salon Management software, exclusively designed for salons, spas, and beauty parlours. It offers features like billing, appointment booking, CRM, business management, marketplace integration, bulk messaging, and many  more. it's Super easy to use, so you can manage your salon smarter, faster, and stress-free."
      />

      {/* <meta name="keywords" content={keywords} /> */}
      <meta
        name="keywords"
        content="India’s No.1 all in one Salon Management Software , Salon Software India, Best Salon Management Software, Salon POS Software, Salon CRM Software, Salon Billing Software, Online Salon Booking System, Cloud-based Salon Software, Beauty Parlour Software India, Spa and Salon Software India, Salon Management App, Beauty Salon Software , All in One Software for Salons, Spas & Beauty Clinics,spa management software India,online salon booking system,beauty parlour software, elegant prime  salon software,salon scheduling software, hair salon software, easy salon software, salon booking software, salon management software, salon software , Salon software with bulk SMS and marketing tools,Salon billing app India,All-in-one salon software for spa and beauty parlour,Budget-friendly salon software with appointment booking,Affordable salon management software,Low-cost salon software,Cloud-based salon software India"
      />

      {canonical && <link rel="canonical" href={canonical} />}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
